import React, { createContext, useContext, useState, ReactNode } from "react";
import { ProductInfo } from "common/interfaces";
import { UploadFile } from "antd";
import { useIndexedDBFileList } from "common/hooks/useIndexedDBFileList";

type CommonContextType = {
  productInfoContext?: ProductInfo | null;
  setProductInfoContext: (data: ProductInfo | null) => void;
  fileList?: UploadFile[] | [];
  setFileList: (data: UploadFile[] | []) => void;
  clearFileList: () => void;
  headerTitle: string;
  setHeaderTitle: (headerTitle: string) => void;
  headerTitleMobile: string;
  setHeaderTitleMobile: (headerTitle: string) => void;
  openMenuBoxMobile: boolean;
  setOpenMenuBoxMobile: (headerTitle: boolean) => void;
};

const CommonContext = createContext<CommonContextType | undefined>(undefined);

export const CommonProvider = ({ children }: { children: ReactNode }) => {
  const [productInfoContext, setProductInfoContext] =
    useState<ProductInfo | null>(null);
  const [fileList, setFileList, clearFileList] = useIndexedDBFileList([]);
  const [headerTitle, setHeaderTitle] = useState<string>("ダッシュボード");
  const [headerTitleMobile, setHeaderTitleMobile] = useState<string>("");
  const [openMenuBoxMobile, setOpenMenuBoxMobile] = useState(false);

  return (
    <CommonContext.Provider
      value={{
        productInfoContext,
        setProductInfoContext,
        fileList,
        setFileList,
        clearFileList,
        headerTitle,
        setHeaderTitle,
        headerTitleMobile,
        setHeaderTitleMobile,
        openMenuBoxMobile,
        setOpenMenuBoxMobile,
      }}
    >
      {children}
    </CommonContext.Provider>
  );
};

export const useCommonContext = () => {
  const context = useContext(CommonContext);
  if (!context) {
    throw new Error("useCommonContext must be used within a CommonProvider");
  }
  return context;
};
